import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CheckInput } from "../../../../../common/Input";

const EmployeeTransactionAccessAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [form, setForm] = useState({
    allowSkipApproval: false,
    isEmployeeTransactionAssignmentManager: false,
    isEmployeeTransactionCompensationManager: false,
    isEmployeeTransactionScheduleManager: false,
    isEmployeeTransactionAssignedEmployee: false,
  });

  useEffect(() => {
    if (isOpen && selectedItem) {
      setForm({
        allowSkipApproval: !!selectedItem.allowSkipApproval,
        isEmployeeTransactionAssignmentManager: !!selectedItem.isEmployeeTransactionAssignmentManager,
        isEmployeeTransactionCompensationManager: !!selectedItem.isEmployeeTransactionCompensationManager,
        isEmployeeTransactionScheduleManager: !!selectedItem.isEmployeeTransactionScheduleManager,
        isEmployeeTransactionAssignedEmployee: !!selectedItem.isEmployeeTransactionAssignedEmployee,
      });
    }
  }, [selectedItem, isOpen]);

  // MODIFIED: Logic to determine mutual exclusivity
  const isAnyFirstFourChecked =
    form.allowSkipApproval ||
    form.isEmployeeTransactionAssignmentManager ||
    form.isEmployeeTransactionCompensationManager ||
    form.isEmployeeTransactionScheduleManager;

  const isAssignedEmployeeChecked = form.isEmployeeTransactionAssignedEmployee;

  const handleToggle = (field, val) => {
    setForm(prev => ({ ...prev, [field]: val }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 overflow-auto" style={{ marginTop: 0 }}>
      <div className="bg-white w-full md:w-[500px] rounded-lg shadow-xl flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold">Update Access Settings</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer"><CloseIcon /></button>
        </div>

        <div className="p-6 space-y-4">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Access Type</label>
            <input
              value={selectedItem?.description || ""}
              disabled
              className="w-full p-2 border border-gray-300 rounded bg-gray-100 text-gray-600"
            />
          </div>

          <div className="border rounded-lg p-2 space-y-1">
            <h3 className="text-sm font-semibold px-2 mb-2 text-gray-500 uppercase">Permissions</h3>

            {/* Added isEditMode prop to handle strict blocking */}
            <CheckInput
              name="Allow Skip Approval"
              value={form.allowSkipApproval}
              onChange={(val) => handleToggle("allowSkipApproval", val)}
              isEditMode={!isAssignedEmployeeChecked}
            />
            <CheckInput
              name="Assignment Manager"
              value={form.isEmployeeTransactionAssignmentManager}
              onChange={(val) => handleToggle("isEmployeeTransactionAssignmentManager", val)}
              isEditMode={!isAssignedEmployeeChecked}
            />
            <CheckInput
              name="Compensation Manager"
              value={form.isEmployeeTransactionCompensationManager}
              onChange={(val) => handleToggle("isEmployeeTransactionCompensationManager", val)}
              isEditMode={!isAssignedEmployeeChecked}
            />
            <CheckInput
              name="Schedule Manager"
              value={form.isEmployeeTransactionScheduleManager}
              onChange={(val) => handleToggle("isEmployeeTransactionScheduleManager", val)}
              isEditMode={!isAssignedEmployeeChecked}
            />

            <div className="border-t my-2 border-gray-100"></div>

            <CheckInput
              name="Assigned Employee"
              value={form.isEmployeeTransactionAssignedEmployee}
              onChange={(val) => handleToggle("isEmployeeTransactionAssignedEmployee", val)}
              isEditMode={!isAnyFirstFourChecked}
            />

            {/* ADDED: Visual Feedback Warning */}
            {isAnyFirstFourChecked && (
              <p className="text-xs text-orange-600 px-2 mt-2 italic">
                * "Assigned Employee" is disabled because a Manager role is selected.
              </p>
            )}
            {isAssignedEmployeeChecked && (
              <p className="text-xs text-orange-600 px-2 mt-2 italic">
                * Manager roles are disabled because "Assigned Employee" is selected.
              </p>
            )}
          </div>
        </div>

        <div className="flex justify-end space-x-2 p-5 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded border-none cursor-pointer">Cancel</button>
          <button onClick={() => onSave(form)} className="px-6 py-2 bg-blue-600 text-white rounded border-none cursor-pointer">Save Changes</button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeTransactionAccessAddEditModal;